import {DisposableObject} from "../../../../utils/disposable-object";

export class DisposableBurnoutAnimationDependencies extends DisposableObject {
    setTimeout(handler: () => void, timeout?: number) {
        this.addNamedTimeout(undefined, handler, timeout)
    }
}